import { IValidationFormContacts } from './interfaces';

export const ValidationFormContacts = ({
  phone,
  msg,
  setErrorPhone,
  setErrorMsg,
  email,
  setErrorEmail,
  requireEmail,
}: IValidationFormContacts) => {
  let err = 0;

  if (msg.length === 0) {
    setErrorMsg('Пожалуйста, заполните поле');
    err = 1;
  } else {
    setErrorMsg(null);
  }

  if (phone === '+7 (___) ___-__-__' || phone.replace(/[^0-9]/g, '').length < 11) {
    setErrorPhone('Пожалуйста, заполните поле');
    err = 1;
  } else {
    setErrorPhone(null);
  }

  if (requireEmail && setErrorEmail) {
    const value = (email || '').trim();
    if (value.length === 0) {
      setErrorEmail('Пожалуйста, заполните поле');
      err = 1;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrorEmail('Введите корректный email');
      err = 1;
    } else {
      setErrorEmail(null);
    }
  }

  if (err) {
    return false;
  }

  return true;
};
